import { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { FSDateField } from '@/ui/components/input/FSDateField';
import { FSImageField } from '@/ui/components/input/FSImageField';
import { UploadImageServiceFake } from '@/ui/components/input/FSImageField.utils/upload-image-service-fake';
import { FSTextField } from '@/ui/components/input/FSTextField';

export function DevImportImage() {
  return (
    <>
      <ImageField1 />
      <hr />
      <ImageField2 />
      <hr />
      <ImageField3 />
      <hr />
      <ImageFieldInForm />
    </>
  );
}

function ImageField1() {
  const [selectedImage, setSelectedImage] = useState<string>('');
  return (
    <>
      <p>no image</p>
      <FSImageField
        name="image-f1"
        value={selectedImage}
        onChange={(image) => setSelectedImage(image)}
      />
    </>
  );
}

function ImageField2() {
  const [selectedImage, setSelectedImage] = useState<string>(
    'https://picsum.photos/200/300',
  );
  return (
    <>
      <p>with image already set</p>
      <FSImageField
        name="image-f2"
        value={selectedImage}
        onChange={(image) => {
          console.log('onChange', image);
          setSelectedImage(image);
        }}
      />
    </>
  );
}

function ImageField3() {
  const [selectedImage, setSelectedImage] = useState<string>('');
  return (
    <>
      <p>with upload service fake</p>
      <FSImageField
        name="image-f2"
        value={selectedImage}
        onChange={(image) => {
          console.log('onChange', image);
          setSelectedImage(image);
        }}
        uploadImageService={new UploadImageServiceFake()}
      />
    </>
  );
}

type Inputs = {
  text: string;
  image1: string;
  image2: string;
  image3: string;
  date: string;
};
function ImageFieldInForm() {
  const { handleSubmit, register, setValue, watch, control } = useForm<Inputs>({
    defaultValues: {
      // text: 'text',
      image1: '',
      // image1: undefined,
      image2: 'https://lipsum.app/random/100x100',
      // image3: 'https://lipsum.app/random/100x100',
      // date: '',
    },
  });

  const onSubmit = (data: Inputs) => {
    console.log('submit', data);
  };
  console.log(watch('text'));
  console.log(watch('date'));
  console.log('1', watch('image1'));
  console.log('2', watch('image2'));
  console.log('3', watch('image3'));

  const image1Value = watch('image1');

  return (
    <>
      <h2>FSImageField in form with react-hook-form</h2>
      <form onSubmit={handleSubmit(onSubmit)}>
        {/* text */}
        <FSTextField label="text field" register={register('text')} />
        {/* date */}
        <FSDateField
          label="date (Control field)"
          name="date"
          control={control}
        />
        {/* image solution 1 : with set value + get */}
        <FSImageField
          name="image1"
          value={image1Value}
          onChange={(image) => {
            console.log(image);
            setValue('image1', image);
          }}
        />
        {/* image solution 2 + Crontoller */}
        <Controller
          control={control}
          name="image2"
          render={({ field }) => (
            <FSImageField
              name={field.name}
              value={field.value}
              onChange={(fileUrl) => {
                console.log('s', fileUrl);
                field.onChange(fileUrl);
                // field.
              }}
            />
          )}
        />
        {/* image default value */}
        <Controller
          control={control}
          name="image3"
          render={({ field }) => (
            <FSImageField
              name={field.name}
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
        <input type="submit" />
      </form>
    </>
  );
}
